import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;

  border-radius: 10px;
  padding: 15px;
  margin-top: 15px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
`;

export const DivLeft = styled.div``;

export const ScheduleLanguageName = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 5px;

  img {
    width: 20px !important;
    height: 20px !important;
    margin-right: 5px;
    position: relative;
    top: 4px;
  }
`;

export const ScheduleDateTime = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 6px;
`;

export const ScheduleLanguageDetails = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 6px;

  .regular {
    font-weight: 700;
    color: #000000;
  }
  .specific {
    font-weight: 700;
    color: #004fff;
  }

  .teacherLanguageType{
    color: #004fff;
    font-weight: 700;
    text-transform: capitalize;
  }
`;

export const ScheduleLanguagePeople = styled.p`
  color: #004FFF;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 5px;

  strong {
    font-weight: 700;
  }
`;

export const DivRight = styled.div`
  width: 39%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
`;

export const WrapperIcons = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  div {
    display: flex;
    align-items: center;
    flex-direction: column;

    label {
      font-size: 13px;
      font-weight: 700;
      line-height: 18px;
    }
  }
`;

export const WrapperButton = styled.div`
  display: flex;
  gap: 10px;
`;

export const ButtonView = styled.button`
  font-size: 11px;
  color: #004fff;

  padding: 5px 12px;
  border-radius: 26px;
  border: 1px solid #004fff;
  background-color: #fff;
  cursor: pointer;
`;

export const ButtonClassRoom = styled.button`
  font-size: 11px;
  color: #fff;

  padding: 5px 12px;
  border-radius: 26px;
  border: 1px solid #004fff;
  background-color: #004fff;
  cursor: pointer;
`;
